export const validActions = ['acheter', 'vendre', 'echanger', 'utiliser'];

export const validCryptos = [
  'bitcoin', 'ethereum', 'bnb', 'usdt', 'ada', 'solana', 'shiba', 'dogecoin', 'perfectmoney','advanced_cash', 'hamster_combat',
  'pepe', 'shiba-inu', 'tron', 'payeer', 'volet','cryptomonnaie','monnaie_numerique'
];

export const validCountries  = {
    benin: 'au',
    burkina_faso: 'au',
    cote_divoire: 'en',
    'cameroun':'au',
    congo: 'au',
    gabon: 'au',
    gambie: 'en',
    ghana: 'au',
    guinee: 'en',
    'guinee_bissau': 'en',
    'guinee_equatoriale': 'en',
    liberia: 'au',
    mali: 'au',
    mauritanie: 'en',
    niger: 'au',
    nigeria: 'au',
    senegal: 'au',
    sierra_leone: 'en',
    togo: 'au',
    'republique_du_congo': 'en',
    'republique_democratique_du_congo': 'en',
    'tchad': 'au',
    'rdc' : 'en',
    'afrique': 'en',
  };
  
export const getPrepositionForCountry = (country) => {
  return validCountries[country] || 'au';
};